import { Fragment } from 'react/jsx-runtime'
import { AdminGuardProps } from './props'
import authStore from '../../../store/authStore'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'
import links from '../../../routes/links'
import PERMISSIONS from '../../../private/permissions'

export default function AdminGuard(props: AdminGuardProps) {
  const location = useLocation()
  const navigate = useNavigate()
  const user = authStore(state => state.user)

  useEffect(() => {
    if (!user) navigate(links.auth.login({ redirectBack: location.pathname }))
    else if (!PERMISSIONS.getBackofficerEmails().includes(user.email as string)) navigate(links.public.home())
    else {
      // TODO: fetch db user or do other checker here
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  if (!!user) return <Fragment>{props.children}</Fragment>
  return null
}
